import React, { Component } from 'react'
import styled from 'styled-components'
import IconButton from 'material-ui/IconButton'
import Menu, { MenuItem } from 'material-ui/Menu'
import MenuIcon from 'material-ui-icons/Menu'
import Media from 'react-media'
import { breakPoints } from 'shared/breakPoints'
import novoLogoWhite from 'images/novologowhite.png'

class Nav extends Component {
  state = {
    anchorEl: null,
  }

  handleClick = e => {
    this.setState({ anchorEl: e.currentTarget })
  }

  handleClose = e => {
    this.setState({ anchorEl: null })
  }

  render() {
    const { anchorEl } = this.state
    const contactUs =
      document.getElementById('contactForm') || document.getElementById('root')
    const team =
      document.getElementById('team') || document.getElementById('root')

    return (
      <NavRoot>
        <Media query={breakPoints.desktop}>
          {matches =>
            matches ? (
              <Links>
                <img
                  src={novoLogoWhite}
                  style={{
                    height: '35px',
                    paddingLeft: '32px',
                    margin: '32px 0',
                  }}
                  alt="logo"
                />

                <div style={{ paddingRight: 32 }}>
                  <a
                    href="#team"
                    style={{
                      margin: '0 8px',
                      color: 'white',
                      textDecoration: 'none',
                    }}
                  >
                    team
                  </a>
                  <a
                    href="#contactForm"
                    style={{
                      margin: '0 8px',
                      color: 'white',
                      textDecoration: 'none',
                    }}
                  >
                    contact us
                  </a>
                </div>
              </Links>
            ) : (
              <Links>
                <img
                  src={novoLogoWhite}
                  style={{ height: '30px', paddingLeft: '16px' }}
                  alt="logo"
                />

                <span />

                <IconButton
                  aria-owns={anchorEl ? 'navigation' : null}
                  aria-haspopup="true"
                  onClick={this.handleClick}
                >
                  <MenuIcon color="inherit" />
                </IconButton>

                <Menu
                  id="navigation"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={this.handleClose}
                >
                  <MenuItem
                    onClick={() => {
                      this.handleClose()
                      team.scrollIntoView({ behavior: 'smooth' })
                    }}
                  >
                    team
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      this.handleClose()
                      contactUs.scrollIntoView({ behavior: 'smooth' })
                    }}
                  >
                    contact us
                  </MenuItem>
                </Menu>
              </Links>
            )
          }
        </Media>
      </NavRoot>
    )
  }
}

const NavRoot = styled.nav.withConfig({ displayName: 'Nav' })`
  background: rgba(0, 0, 0, 0.65);
  position: fixed;
  top: 0;
  width: 100%;

  svg {
    color: white;
  }

  z-index: 1;
`

const Links = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: auto;
  min-height: 56px;
  max-width: 1200px;
  width: 100%;
`

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav.js